import { ChangeDetectorRef, Component, ElementRef, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import Quill from 'quill';
import QuillTableBetter from 'quill-table-better';
import { IDropdownOptions, SharedDataService } from '../../@core/service/shared-data.service';
import * as moment from 'moment';
import { ApiService } from '../../@core/service/api.service';
import { ToasterService } from 'angular2-toaster';
import { NbToastrService } from '@nebular/theme';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs';
import { BusinessModel, ContactModel } from '../../@models';
import { CompilationModel } from '../../@models/erp/compilation';
import { mongoId } from '../../@core/common/global';
import { DocumentStatusData } from '../../@models/erp/compilationData';
import { NbPopoverDirective } from '@nebular/theme';

interface IMailData {
  recipient: string,
  subject: string,
  message: string,
}

interface IActionPointData {
  text: string;
  items: ActionPointItem[]
}

class ActionPointItem {

  new: string = '';
  issueDate: Date = new Date();
  rsm: ContactModel = null;
  customer: BusinessModel;
  doc: string = '';
  description: string = '';
  responsible: ContactModel; // TODO: remove legacy
  actionPoint: string = ''; // TODO: remove legacy
  dueDate: Date; // TODO: remove legacy
  status: string;
  actions: {
    responsible: ContactModel;
    responsibleText: string;
    actionPoint: string;
    dueDate: Date;
    completed: boolean;
  }[] = [{
    responsible: null,
    responsibleText: '',
    actionPoint: '',
    dueDate: null,
    completed: false,
  }]

}

@Component({
  selector: 'app-action-point-mail',
  templateUrl: './action-point-mail.component.html',
  styleUrls: ['./action-point-mail.component.scss']
})
export class ActionPointMailComponent implements OnInit {

  @Input() dataRef: string;

  @Input() mailData: IMailData = {
    recipient: '',
    subject: '',
    message: ''
  };
  @Output() mailDataChange = new EventEmitter<IMailData>(); 

  @ViewChild('preview') preview: ElementRef<HTMLDivElement>;

  subjectOverride = `${moment().format('YYMMDD')} ${moment().format('YY')}CW${moment().format('WW')} Overview NR Europe`

  actionHeaderText: string = '';
  actionPoints: ActionPointItem[] = [];

  compilationOptions: IDropdownOptions[] = [];

  protected actionPointOptions = [
    { id: 'new', name: 'New '},
    { id: 'inProgress', name: 'In Progress'},
    { id: 'onHold', name: 'On Hold'},
    { id: 'completed', name: 'Completed'},
  ]

  constructor(
    private cdRef: ChangeDetectorRef,
    protected data: SharedDataService,
    private api: ApiService,
    private toast: NbToastrService,
    private route: ActivatedRoute
  ) { 
    this.route.queryParams.pipe(take(1)).subscribe(params => {
      this.dataRef = params.dataRef;
      console.log('dataref', this.dataRef);
      this.init();
    })
  }

  // quillModules =  {
  //   toolbar: [
  //     ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
  //     ['blockquote', 'code-block'],

  //     [{ 'header': 1 }, { 'header': 2 }],               // custom button values
  //     [{ 'list': 'ordered' }, { 'list': 'bullet' }],
  //     [{ 'script': 'sub' }, { 'script': 'super' }],
  //     [{ 'indent': '-1' }, { 'indent': '+1' }],         // outdent/indent
  //     [{ 'direction': 'rtl' }],                         // text direction

  //     [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
  //     [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

  //     [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults
  //     [{ 'font': [] }],
  //     [{ 'align': [] }],

  //     ['link', 'image', 'video'], // remove 'image' if needed
  //     ['clean'],                         // remove formatting
  //     ['table-better']
  //   ],
  //   table: false,
  //   blotFormatter: {},
  //   keyboard: {
  //     bindings: QuillTableBetter.keyboardBindings
  //   },
  //   'table-better': {
  //     language: 'en_US',
  //     menus: [
  //       'column',
  //       'row',
  //       'merge',
  //       'table',
  //       'cell',
  //       'wrap',
  //       'copy',
  //       'delete',
  //     ],
  //     toolbarTable: true,
  //   },
  // }
  
  async ngOnInit() {

  }

  async init() {
    await this.data.loadCompilationData();
    await this.data.loadContacts();
    await this.data.loadBusinesses();
    

    // this.compilationOptions = (await this.api.filterCompilations({ documentStatus: DocumentStatusData.get('final').id}, "code", true))
    //   .sort((a,b) => b.code.localeCompare(a.code))
    //   .map(m => ({ id: m.code, name: m.code }));

    const report = this.data.compilationData[this.dataRef]
    // console.log('init', this.dataRef, report, this.data.compilationData)
    if (report) {
      this.mailData.recipient = report[0].data?.[0];
      this.mailData.subject = this.subjectOverride;
      if (btoa(report[2]?.data)?.length) this.mailData.subject = report[2]?.data;
      if (!report[6]?.data) report[6] = { id: 'actionPointMailtext', name: 'Action Point Table', data: '' };
      if (!report[7]?.data) report[7] = { id: 'actionPointHeader', name: 'Action Point Header', data: '' };
      if (!report[8]?.data) report[8] = { id: 'actionPointData', name: 'Action Point Data', data: [] as any };
      this.mailData.message = report[6].data
      this.actionHeaderText = report[7].data
      this.actionPoints = report[8].data as unknown as ActionPointItem[];
      this.actionPoints.forEach(ap => {
        if (!ap.actions?.length) {
          ap.actions = [{
            responsible: ap.responsible,
            responsibleText: '',
            actionPoint: ap.actionPoint,
            dueDate: ap.dueDate,
            completed: false,
          }]
        }
      })
    }        
      // case 'report2':
      //   const report2 = this.data.compilationData.reportsMail2
      //   if (report2) {
      //     this.mailData.recipient = report2[0].data;
      //     if (!report2[2]?.data) this.mailData.subject = `${moment().format('YYMMDD')} Activity Overview NRK Europe`
      //     this.mailData.message = report2[3].data
      //   }        
      //   break;
    // this.info = await this.api.getWeeklyEmailInfo();

    // console.log('initial action ponts', this.actionPoints);

  }

  onMailDataChanged(data: any) {
    console.log('mailData', this.dataRef, data);
    // this.mailDataChange.emit(data);
    if (window.opener && typeof window.opener.onPopupData === 'function') {
      window.opener.onPopupData(data);
    }
  }

  async setCompilationOptions(business: string) {
    this.compilationOptions = (await this.api.filterCompilations({ documentStatus: DocumentStatusData.get('final').id, recipient: mongoId(business) }, "code customerDocumentNumber", true))
      .sort((a,b) => b.code.localeCompare(a.code))
      .map(m => ({ id: m.code, name: `${m.code} - ${m.customerDocumentNumber || ''}` }));
    console.log('set compilation options', this.compilationOptions)
  }

  onDocSelected() {
    this.compilationOptions = [];
    console.log('on doc selected', )
  }

  // async onEditorCreated(quill: Quill) {
  //   console.time('editor created');
  //   await new Promise((res) => {
  //     let timeout = 1000
  //     const timer = setInterval(() => {
  //       // console.log(timeout < 0 || this.editorItems[3]);
  //       if (timeout < 0 || this.mailData.message) {
  //         clearInterval(timer);
  //         res(true);
  //       }
  //       timeout -= 10;
  //     }, 10)
  //   });
  //   // if (!this.editorItems[3]?.data) return;
  //   console.timeEnd('editor created');
  //   console.log(this.mailData.message);
  //   //quill.setContents(quill.clipboard.convert({html: this.editorItems[3].data}), 'silent')
  //   const delta = quill.clipboard.convert({ html: this.mailData.message });
  //   const [range] = quill.selection.getRange();
  //   quill.updateContents(delta, Quill.sources.USER);
  //   quill.setSelection(
  //     delta.length() - (range?.length || 0),
  //     Quill.sources.SILENT
  //   );
  //   quill.scrollSelectionIntoView();
  //   this.cdRef.markForCheck();
  // }

  // saveActionPoints() {
  //   console.log('send mail');
  // }

  evalActionPoints() {
    this.mailData.message = `<div style="padding-bottom:1rem">${this.actionHeaderText}</div>${this.preview.nativeElement.innerHTML}`;
    this.data.compilationData[this.dataRef][6].data = this.mailData.message;        
    this.data.compilationData[this.dataRef][7].data = this.actionHeaderText;        
    this.data.compilationData[this.dataRef][8].data = this.actionPoints as any;
  }

  async saveReportMailData() {

    console.log('this.mailData.subject', this.dataRef, this.mailData.subject[0] === this.subjectOverride, this.dataRef);
    if (this.mailData.subject !== this.subjectOverride) this.data.compilationData[this.dataRef][2].data = this.mailData.subject;
    this.evalActionPoints();
    await this.api.saveCompilationData(this.dataRef, this.data.compilationData[this.dataRef]).then(() => {
      this.onMailDataChanged(this.data.compilationData[this.dataRef]);
      this.toast.success('Data successfully saved', 'Action Points');
    }).catch(err => {
      console.error(err);
      this.toast.danger('Error saving data', 'Error');
    });
  }

  async sendMail() {
    console.log('recipient', this.mailData.recipient)
    this.evalActionPoints();
    this.api.sendmail(
      this.mailData.recipient.split(/[\r\n]+/).join(','),
      'Action Point Report',
      this.mailData.subject + ' updated Action points',
      this.mailData.message
    ).then(() => {
        this.toast.success('Mail successfully sent', 'Action Points');
      }).catch(err => {
        console.error(err);
        this.toast.danger('Error sending mail', 'Error');
      });
  }

  updateSorting() {
    console.log('update sorting before', this.actionPoints);

    // sort actions
    this.actionPoints.forEach(ap => {
      // Sort by dueDate ascending (nulls last)
      ap.actions = ap.actions.sort((a, b) => {
        const aDue = a.dueDate ? new Date(a.dueDate).getTime() : Infinity;
        const bDue = b.dueDate ? new Date(b.dueDate).getTime() : Infinity;
        return aDue - bDue;
      })
    })


    this.actionPoints = this.actionPoints.sort((a, b) => {
      // 1. Move completed status to the end
      const aCompleted = a.status === 'completed';
      const bCompleted = b.status === 'completed';
      if (aCompleted !== bCompleted) {
        return aCompleted ? 1 : -1; // completed goes last
      }

      // 2. Sort by rsm.name (assuming it's a string and can be null)
      const aRsmName = this.data.getOptionName(this.data.contactOptions, a.rsm)?.toLowerCase() || ''
      const bRsmName = this.data.getOptionName(this.data.contactOptions, b.rsm)?.toLowerCase() || ''
      if (aRsmName !== bRsmName) {
        return aRsmName.localeCompare(bRsmName);
      }

      // 2a. Sort by customer
      const aCustomerName = this.data.getOptionName(this.data.businessOptions, a.customer)?.toLowerCase() || ''
      const bCustomerName = this.data.getOptionName(this.data.businessOptions, b.customer)?.toLowerCase() || ''
      if (aCustomerName !== bCustomerName) {
        return aCustomerName.localeCompare(bCustomerName);
      }

      // 3. Items with new === '!' come first
      const aIsNew = this.isNew(a);
      const bIsNew = this.isNew(b);
      if (aIsNew !== bIsNew) {
        return aIsNew ? -1 : 1;
      }

      // // 4. Sort by dueDate ascending (nulls last)
      // const aDue = a.dueDate ? new Date(a.dueDate).getTime() : Infinity;
      // const bDue = b.dueDate ? new Date(b.dueDate).getTime() : Infinity;
      // return aDue - bDue;
    })
    console.log('update sorting after', this.actionPoints);
  }

  addItem(idx: number) {
    const item = new ActionPointItem();
    this.actionPoints.splice(idx+1, 0, item);
    console.log('add items', idx, this.actionPoints);
  }

  removeItem(idx: number) {
    this.actionPoints.splice(idx, 1);
    console.log('remove items', idx, this.actionPoints);
  }

  addAction(idx: number, aidx: number) {
    const item = { responsible: null, responsibleText: '', actionPoint: '', dueDate: null, completed: false };
    this.actionPoints[idx].actions.splice(aidx+1, 0, item);
    console.log('add action', idx, this.actionPoints);
  }

  removeAction(idx: number, aidx: number) {
    this.actionPoints[idx].actions.splice(aidx, 1);
    console.log('remove action', idx, this.actionPoints);
  }

  isNew = (item: ActionPointItem) => moment(item.issueDate).isAfter(moment().startOf('week')); 

  setRsm(item: ActionPointItem, business: string) {
    console.log('setRsm', item, business);
    return item.rsm = mongoId(this.data.businesses.find(f => mongoId(f) === business).manager) as ContactModel; 
  }

  getRowStyle(item: ActionPointItem, action: Partial<ActionPointItem>) {
    if (item.status === 'completed') {
      return 'background-color: #bfb'
    }
    // if (moment(action.dueDate).isBefore(moment().startOf('day'))) {
    //   // console.log('due date - start of day - isbefore', moment(action.dueDate), moment().startOf('day'), moment(action.dueDate).isBefore(moment().startOf('day')));
    //   return 'background-color: #fbb' 
    // }
  }

  getActionStyle(item: ActionPointItem, action: ActionPointItem["actions"][number], style='') {

    if (item.status === 'completed') {
      return style;
    }

    if (action.completed) {
      return 'background-color: #bfb;' + style;
    }

    if (moment(action.dueDate).isBefore(moment().startOf('day'))) {
      // console.log('due date - start of day - isbefore', moment(action.dueDate), moment().startOf('day'), moment(action.dueDate).isBefore(moment().startOf('day')));
      return 'background-color: #fbb;' + style; 
    }
    
    return style;
  }


  checkForCompletedHeader(item: ActionPointItem): boolean {
    const index = this.actionPoints.indexOf(item);

    // If item not found, or not completed, return false early
    if (index === -1 || item.status !== 'completed') {
      return false;
    }

    // Ensure all items after this index are completed
    const allAfterAreCompleted = this.actionPoints
      .slice(index)
      .every(i => i.status === 'completed');

    // Ensure either it's the first item or the item before is not completed
    const isFirstCompleted = index === 0 || this.actionPoints[index - 1].status !== 'completed';

    return allAfterAreCompleted && isFirstCompleted;
  }

  onValueChange(event: boolean, item: ActionPointItem) {
    console.log('onValuechange', event, item, !item.actions.some(action => !action.completed));
    if (event === true && !item.actions.some(action => !action.completed)) {
      item.status = 'completed';
    }
  }
}
